import React, { Children } from 'react';
import cn from 'classnames';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image from 'tbk-components/src/components/Image';
import Form from '../Form';
import textLogo from '../../assets/logo-text.svg';

export interface INewsletterProps extends IBaseElementProps {
	heading?: string;
	content?: string;
	showLogo?: boolean;
	children?: any;
}

/**
 * Newsletter
 * @block
 * @requiresHooks
 */

const Newsletter: React.FC<INewsletterProps> = ({
	className,
	classNames = [],
	children,
	heading,
	content,
	showLogo,
}) => (
	<div
		className={
			className || cn('newsletter', 'container-fluid', ...classNames)
		}
	>
		<div className="newsletter__wrapper">
			<div className="newsletter__content">
				{showLogo && (
					<Image
						src={textLogo}
						width={170}
						height={70}
						alt="My Big Yellow Bus"
						className="newsletter__image"
					/>
				)}
				{heading && (
					<h2 className="newsletter__heading">{heading}</h2>
				)}
				{content && <p className="newsletter__body">{content}</p>}
			</div>
			<div className="newsletter__form">
				<Form isCentered classNames={['form-wrapper--newsletter']}>
					{children}
				</Form>
			</div>
		</div>
	</div>
);

export default Newsletter;
